import { Sparkles, ArrowRight, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AIInsightCardProps {
  title: string;
  description: string;
  action?: string;
  onAction?: () => void;
}

export function AIInsightCard({
  title,
  description,
  action,
  onAction,
}: AIInsightCardProps) {
  return (
    <div className="relative group overflow-hidden rounded-xl">
      {/* Animated gradient border */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/50 to-primary rounded-xl opacity-50 group-hover:opacity-70 transition-opacity duration-300" />
      <div className="absolute inset-[1px] bg-card rounded-xl" />
      
      {/* Content */}
      <div className="relative p-5">
        {/* Subtle background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        
        <div className="relative flex items-start gap-4">
          {/* AI Icon with glow */}
          <div className="relative">
            <div className="absolute inset-0 bg-primary/30 rounded-xl blur-lg animate-pulse-glow" />
            <div className="relative p-2.5 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/20">
              <Sparkles className="h-5 w-5 text-primary" />
            </div>
          </div>
          
          <div className="flex-1 space-y-2.5">
            <div className="flex items-center gap-2">
              <h3 className="font-semibold text-foreground">{title}</h3>
              <div className="flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-primary/10 border border-primary/20">
                <Zap className="h-3 w-3 text-primary" />
                <span className="text-[10px] font-semibold text-primary uppercase tracking-wide">AI</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {description}
            </p>
            {action && (
              <Button
                variant="ghost"
                size="sm"
                className="text-primary hover:text-primary hover:bg-primary/10 -ml-3 mt-1 group/btn"
                onClick={onAction}
              >
                {action}
                <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover/btn:translate-x-0.5" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
